import { createAction, props } from '@ngrx/store';
import { Ruler } from './ruler.state';

export namespace fromRulerActions {
  export const AddRuler = createAction(
    '[Ruler] Add Ruler',
    props<{ ruler: Ruler }>()
  );

  export const DeleteRuler = createAction(
    '[Ruler] Delete Ruler',
    props<{ id: string }>()
  );

  export const SelectRuler = createAction(
    '[Ruler] Select Ruler',
    props<{ id: string | null }>()
  );

  export const UpdateRulerDistance = createAction(
    '[Ruler] Update Ruler Distance',
    props<{ id: string; distanceInFeet: number; endPoint: { x: number; y: number; z: number } }>()
  );

  export const ClearAllRulers = createAction('[Ruler] Clear All Rulers');

  // Hydrate the ruler store from persisted design data on initial load /
  // project restore. Used by the meta-data effect that reads the design JSON
  // returned by the quote API.
  export const AddManyRulers = createAction(
    '[Ruler] Add Many Rulers',
    props<{ rulers: Ruler[] }>()
  );

  // Triggers the design auto-save flow so each new / deleted ruler is
  // persisted to the backend, matching the SaveRoofDesign / SaveObstacle
  // pattern. Caught by `saveDesign$` in design.effect.ts.
  export const SaveRulers = createAction('[Ruler] Save Rulers');
}
